import { constants } from "../../../constants";

export default class OpenHelp {
    constructor(gb) {
        Object.assign(this, { gb });
    }

    _default() {
        this.gb.emitters.emit.game.openHelp();
    }

    exposeEvent() {
        let event = {};

        switch (this.gb.walletProtocol) {
            case constants.POKERSTARS:
                event["xc2rgShowHelp"] = this._default;
                break;
            default:
                event["help"] = this._default
        }

        return event;
    }
}
